import styled, { css } from 'styled-components'

const starCss = css`
    display: flex;
    flex-direction: row;
    gap: 5px;
    font-size: 0.75em;
    align-items: center;

    .count {
    }
    .star-rating {
      position: relative;
      appearance: none;
      top: -3px;
      font-size: 1.5em;
      display: inline-block;
      width: 4.5em;


      &:before {
        --value: ${({ value }) => value};
        --percent: calc(var(--value)/5*100%);
        content: '★★★★★';
        position: absolute;
        top: 0;
        left: 0;
        color: rgba(0, 0, 0, 0.6);
        background: linear-gradient(90deg, #ffa41d var(--percent), rgba(0, 0, 0, 0.6) var(--percent));
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
      }
    }
`;
const StarRating = styled(({ className, value, reviewCount, text }) => {

  return (
    <div className={className}>
      <span className='value'>{value}</span>
      <meter className='star-rating' value={value} max="5" title={text}></meter>
      <span className='count'>{reviewCount}</span>
    </div>
  )
})`${starCss}`;

export default StarRating;